import script from "./payroll-overtime-modal.vue?vue&type=script&setup=true&lang=js"
export * from "./payroll-overtime-modal.vue?vue&type=script&setup=true&lang=js"

import "./payroll-overtime-modal.vue?vue&type=style&index=0&id=3fab3f08&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3fab3f08"]])

export default __exports__